module.exports = __webpack_public_path__ + "static/nicolebio2.f5daa9b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nicolebio2.jpg
// module id = 488
// module chunks = 263791100135453